import { DeleteButton, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { CalendarRange } from "lucide-react";
import {
  BooleanInput,
  Edit,
  NumberInput,
  SimpleForm,
  TextInput,
} from "../common";

const LeaveTypeEditToolbar = () => (
  <div className="form-toolbar-premium">
    <DeleteButton className="btn-delete-action" />
    <SaveButton className="btn-green-action" label="Update Leave Type" />
  </div>
);

export const LeaveTypeEdit = () => (
  <Edit title="Edit Leave Type" actions={false}>
    <Card className="form-container">
      <div className="form-header-premium">
        <CalendarRange className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Edit Leave Type</h2>
      </div>
      <SimpleForm toolbar={<LeaveTypeEditToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput source="name" label="Leave Type Name" />
          <TextInput source="code" label="Code" />
          <NumberInput source="days_per_year" label="Days Per Year" />
        </div>
        <div className="flex gap-6 mt-4">
          <BooleanInput source="paid" label="Paid Leave" />
          <BooleanInput source="carry_forward" label="Carry Forward" />
        </div>
      </SimpleForm>
    </Card>
  </Edit>
);
